import { TheirImpactFragment } from "@graphqlTypes";
import { ArtifactSingular, Quote, SoundExplorer, Spotlight, ArtifactPaper, InducteeEssay } from "@components";
import DigitalExhibitQuiz from "@/components/DigitalExhibit/DigitalExhibitQuiz/DigitalExhibitQuiz";

interface ImpactMapProps {
  content: TheirImpactFragment['inducteeData']['impactFlexibleContent'];
}

export default function InducteeImpactMap({ content }: ImpactMapProps) {
  return (
    <>
      {content?.map((component, index) => {
        // Add more cases for other component types as needed
        switch (component.__typename) {
          case "InducteeDataImpactFlexibleContentSoundExplorerLayout":
            return <SoundExplorer key={index} {...component} />;
          case "InducteeDataImpactFlexibleContentArtifactSingularLayout":
            return <ArtifactSingular key={index} {...component} />;
          case "InducteeDataImpactFlexibleContentArtifactPaperLayout":
            return <ArtifactPaper key={index} {...component} />;
          case "InducteeDataImpactFlexibleContentSpotlightLayout":
            return <Spotlight key={index} {...component} />;
          case "InducteeDataImpactFlexibleContentQuoteLayout":
            return <Quote key={index} {...component} />;
          case "InducteeDataImpactFlexibleContentHallOfFameEssayLayout":
            return <InducteeEssay key={index} {...component} />;
          case "InducteeDataImpactFlexibleContentQuizLayout":
            return <DigitalExhibitQuiz key={index} {...component} isDefault />;
          default:
            // @ts-ignore Handle unknown component types gracefully
            console.warn(`No component found for type: ${component.__typename}`);
            return null;
        }
      })}
    </>
  );
}
